<template>
  <div v-if="item.children.length == 0">
    <el-menu-item :index="item.path" @click="handleMenuClick(item)">
      <i :class="item.meta.icon"></i>
      <span slot="title">{{ item.meta.title }}</span>
    </el-menu-item>
  </div>

  <el-submenu v-else :index="item.path">
    <template slot="title">
      <i :class="item.meta.icon"></i>
      <span>{{ item.meta.title }}</span>
    </template>

    <template v-for="child in item.children">
      <sidebar-item v-if="child.children && child.children.length > 0" :item="child" :key="child.path" />
      <el-menu-item v-else :key="child.path" :index="child.path" @click="handleMenuClick(child)">
        <i :class="child.meta.icon"></i>
        {{ child.meta.title }}
      </el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleMenuClick(item) {
      //console.log(item)
      //this.$store.commit("keepCurrentIndex", item.path)
      this.$router.push({ path: item.path })
    }
  }
}
</script>
